export enum DeliveryStatus {
    notOrdered = 1,
    ordered = 2,
    readyToShip = 3,
    shipped = 4,
    storage = 5,
    notStarted = 6
}
